class CollectionScrollPosition {
  constructor () {
    // Last clicked item data
    this.lastClickedItemHrefKey =
      'collectionScrollPosition-lastClickedItemHref'
    this.lastClickedItemHref = sessionStorage.getItem(
      this.lastClickedItemHrefKey,
    )

    // Last visited url data
    this.lastVisitedUrlsKey =
      'collectionScrollPosition-lastVisitedCollectionUrl'
    this.lastVisitedUrls = sessionStorage.getItem(this.lastVisitedUrlsKey)

    this.currentUrl = this.urlToPathName(window.location.href)

    this.initialise()
  }

  initialise () {
    if (this.currentUrl.includes('/collections/')) {
      this.handleCollectionTemplate()
    } else if (this.currentUrl.includes('/products/')) {
      this.handleProductTemplate()
    } else {
      this.clearData()
    }
  }

  handleCollectionTemplate () {
    this.updateLastVisistedUrls(this.currentUrl)

    // Disable browser's native scrollRestoration
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual'
    }

    if (this.lastVisitedCollectionUrl === this.currentUrl) {
      this.clearData()
    }

    this.restoreScrollPosition()
    this.captureScrollPosition()
  }

  handleProductTemplate () {
    this.updateLastVisistedUrls(this.currentUrl)
  }

  restoreScrollPosition () {
    // Retrieve and restore last position
    if (this.lastClickedItemHref && this.lastClickedItemHref !== 'undefined') {
      document
        .querySelector(`a[href="${this.lastClickedItemHref}"]`)
        ?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
        })
    }
  }

  captureScrollPosition () {
    // Capture clicked item
    window.addEventListener('click', (e) => {
      const anchor = e.target.closest('a')
      this.lastClickedItemHref = anchor ? anchor.getAttribute('href') : null
    })

    // Capture beforeunload event
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem(
        this.lastClickedItemHrefKey,
        this.lastClickedItemHref || '',
      )
    })
  }

  updateLastVisistedUrls (url) {
    const array = this.lastVisitedUrls
      ? [...JSON.parse(this.lastVisitedUrls)]
      : []
    array.push(url)

    const lastItem = array[array.length - 1]
    const secondToLastItem = array[array.length - 2]

    if (lastItem === secondToLastItem) {
      // If the last two items are the same, we clear data
      this.clearData()
    } else if (
      lastItem?.includes('/collections/') &&
      secondToLastItem?.includes('/collections/')
    ) {
      // If the last two items are both collections, we clear data
      this.clearData()
    } else {
      sessionStorage.setItem(this.lastVisitedUrlsKey, JSON.stringify(array))
    }
  }

  clearData () {
    sessionStorage.removeItem(this.lastClickedItemHrefKey)
    sessionStorage.removeItem(this.lastVisitedUrlsKey)
    this.lastClickedItemHref = null
    this.lastVisitedUrls = null
  }

  urlToPathName (url) {
    const object = new URL(url)
    return object.pathname
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.BAO.collectionScrollPosition = new CollectionScrollPosition()
})
